import React, { Component, Fragment } from 'react';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Grid,
  Button,
} from '@material-ui/core';
import {InsertChart,GetApp,Close,ExpandMore, ShowChart} from '@material-ui/icons';
import SecondaryButton from 'components/Global/Buttons/SecondaryButton'
import ChartOnlyDialog from 'components/Global/SisenseDialogs/ChartOnlyDialog';

import {
  QuoteComparisonExpansionPanel,
  QuoteComparisonExpansionPanelNoBorder,
  createLoanGridLabel,
  createMoneyLoanGridElements,
  createRateLoanGridElements,
  createDSCRLoanGridElements,
  QuoteComparisonExpansionSummary,
  QuoteComparisonExpansionPanelDetails,
  createIndentedLoanGridLabel
} from '../QuoteComparisonGridElements';
import styled from 'styled-components'

const BlueBorderExpansionPanel = styled(QuoteComparisonExpansionPanel)`
  &&&& {
    border-bottom: 2px solid #2196F3;
    padding-left:0;
  }
`
const AnalysisSummary = styled(QuoteComparisonExpansionSummary)`
  && {
    border-bottom: ${props => props.isopen === "true" ? '1px solid gray;' : ''}
    margin-bottom: ${props => props.isopen === "true" ? '4px;' : ''}
  }
`
const AnalysisExpansionDetails = styled(QuoteComparisonExpansionPanelDetails)`
  && {
    padding: 0;
    padding-left:24px;
  }
`
const QuoteComparisonExpansionSummaryNoPadding = styled(QuoteComparisonExpansionSummary)`
  && {    
    padding: 0;
  }
`
const QuoteComparisonExpansionPanelDetailsNoPadding = styled(QuoteComparisonExpansionPanelDetails)`
  && {
    padding: 0;
  }
`
const Gridster = styled(Grid)`
  &&& {
    padding-right:56px;
  }
`
const Spacer = styled.div`
  flex-grow:1;
`
const IndentedLabel = styled.div`
margin-left: 50px;
`
const RateAnalysis = styled.div`
  border-bottom: 1px solid gray;  
  width:100%;
  font-weight:bold;
  font-size:17px;
`
const StyledShowChart = styled(ShowChart)`
  background-color: #2196F3;
  color: white;
  margin-left: 5px;
`

class AnalysisHeader extends Component {
  state = {
    expanded: true,
    iFrameURL:"",
    modalOpen: false,
  }

  closeModal = () => {
    this.setState({ modalOpen: false });
  }
  handleChange = (event, expanded) => {
    this.setState({
      expanded: expanded,

    });
  }
  getChartComponent = () => {
    //Removing the chart icon until the sisense report can be altered to allow for the correct user interaction
    return null;
    if(this.props.dashboardId != "" && (this.props.authentication.companyLevel==="Professional" 
    || this.props.authentication.companyLevel==="Enterprise"
    || this.props.authentication.companyLevel==="Secondary Sponsor")){
      const or = [];
      this.props.analysisInfo.forEach(x => { or.push({equals:x.loanId}); });
      return <StyledShowChart
                onClick={() => {
                  let filter = [{"jaql":{"table":"loan_yearoveryearvalues","column":"loanId","dim":"[loan_yearoveryearvalues.loanId]","datatype":"numeric","title":"loanId","filter":{"or":or},"datasource":{"title":"loan_yearoveryearvalues","fullname":"live:loan_yearoveryearvalues","id":"live:loan_yearoveryearvalues","live":true,"lastBuildTime":"2020-04-14T16:06:00"},"collapsed":false},"$$events":{},"instanceid":"B8E5E-52CC-A7","$filter":{},"isCascading":false,"$$guid":"99D37-BF3B-3541-F848","$$hashKey":"object:2367"}];
                  const encoded = encodeURIComponent(JSON.stringify(filter));
                  let url = `https://loanboss.sisense.com/api/demoSession/start/${this.props.dashboardId}/?h=false&t=false&l=false&r=false&volatile=true&filter=${encoded}`;                 
                  this.setState({ modalOpen: true, iFrameURL: url });}
                  }
                  fontSize="inherit"/>
    } else 
      return null;
    }

  render() {
    const { isCombined, analysisInfo, isAnalysisOpen, showAnalysis, closeAnalysis, yearOverYearDSCR, yearOverYearDebtYield } = this.props;
    const { expanded, iFrameURL, modalOpen, } = this.state;
    
    return (
        <Fragment>
        <BlueBorderExpansionPanel expanded={isAnalysisOpen} onChange={() => {
          if(isAnalysisOpen){
            closeAnalysis();
          } else {
            showAnalysis();
          }
        }}>
          <AnalysisSummary  
            style={{
              height:'64px'
            }}
            IconButtonProps={{
              disableRipple:true,
              style:{
                width:'200px',
                transform: 'translateY(-50%) rotate(0deg)'
              }
            }} 
            isopen={isAnalysisOpen.toString()}
            expandIcon={this.renderAnalysisButton(isAnalysisOpen, showAnalysis, closeAnalysis)}>
            <Grid container direction="row">
              {createLoanGridLabel("Analysis")}
              <Spacer/>            
            </Grid>
          </AnalysisSummary>
          <AnalysisExpansionDetails>
          {analysisInfo.length > 0 && <Grid container direction="row" justify="flex-start" alignItems="center">          
              <RateAnalysis>Rate Analysis</RateAnalysis>
              <Gridster container>
              <Grid item xs={12}></Grid>
              {createLoanGridLabel("Current Rate")}
              {createRateLoanGridElements(analysisInfo, 'currentRate',isCombined)}
              <Grid item xs={12}></Grid>
              {createLoanGridLabel("Average Projected Rate")}
              {createRateLoanGridElements(analysisInfo, 'averageProjectedRate',isCombined)}
              <Grid item xs={12}></Grid>
              {createLoanGridLabel("Effective Interest Rate")}
              {createRateLoanGridElements(analysisInfo, 'effectiveInterestRate',isCombined)}
              <Grid item xs={12}></Grid>
              {createLoanGridLabel("Wgt Avg Cost of Debt")}
              {createRateLoanGridElements(analysisInfo, 'weightedAverageCostOfDebt',isCombined)}
              <Grid item xs={12}>
                <QuoteComparisonExpansionPanelNoBorder onChange={this.handleChange}>
                  <QuoteComparisonExpansionSummaryNoPadding expanded={expanded} expandIcon={<ExpandMore />}>
                  {createLoanGridLabel("Avg Annual DSCR", this.getChartComponent())}
                  {createDSCRLoanGridElements(analysisInfo, 'averageAnnualDscr',isCombined, "isBusted")}
                  </QuoteComparisonExpansionSummaryNoPadding>
                  {yearOverYearDSCR.map((x, i) => 
                          (<QuoteComparisonExpansionPanelDetailsNoPadding key={`QuoteComparisonExpansionPanelDetailsNoPadding${i}`}>
                              {createIndentedLoanGridLabel(`${x.yoyLabel}`)}
                              {createDSCRLoanGridElements(x.values, 'value', false, "isBusted")}
                          </QuoteComparisonExpansionPanelDetailsNoPadding>))}
                </QuoteComparisonExpansionPanelNoBorder>
              </Grid>
              <Grid item xs={12}>
                <QuoteComparisonExpansionPanelNoBorder onChange={this.handleChange}>
                  <QuoteComparisonExpansionSummaryNoPadding expanded={expanded} expandIcon={<ExpandMore />}>
                  {createLoanGridLabel("Avg Annual Debt Yield", this.getChartComponent())}
                  {createRateLoanGridElements(analysisInfo, 'averageAnnualDebtYield',isCombined, "isBusted")}
                  </QuoteComparisonExpansionSummaryNoPadding>
                  {yearOverYearDebtYield.map((x, i) => 
                          (<QuoteComparisonExpansionPanelDetailsNoPadding key={`QuoteComparisonExpansionPanelDetailsNoPadding${i}`}>
                              {createIndentedLoanGridLabel(`${x.yoyLabel}`)}
                              {createRateLoanGridElements(x.values, 'value', false, "isBusted")}
                          </QuoteComparisonExpansionPanelDetailsNoPadding>))}
                </QuoteComparisonExpansionPanelNoBorder>
              </Grid>            
              <Grid item xs={12}></Grid>
              {createLoanGridLabel("Proj. Prepay Penalty")}
              {createMoneyLoanGridElements(analysisInfo, 'projectedPrepaymentPenalty',isCombined)}
              </Gridster>
            </Grid>}
          </AnalysisExpansionDetails>
        </BlueBorderExpansionPanel>
        <ChartOnlyDialog title={"DSCR & Debt Yield Analysis"} maxWidth={"100%"} iframe={iFrameURL} modalOpen={modalOpen} handleClose={this.closeModal} />
      </Fragment>
    )
  }
  renderAnalysisButton = (isAnalysisOpen, showAnalysis, closeAnalysis) => {
    return (
    <div>
      {!isAnalysisOpen && 
      <SecondaryButton onClick={showAnalysis}>
        <InsertChart/>
        Perform analysis
      </SecondaryButton>
      }
      {isAnalysisOpen && 
      <SecondaryButton onClick={closeAnalysis}>
        <Close/>
        Close analysis
      </SecondaryButton>
      }              
    </div>
    )
  }
}

export default AnalysisHeader;